module.exports = __webpack_public_path__ + "static/media/white-triangle.8b4e8e9e.svg";